import React from "react";
import Name from "../components/Name";
import "./ContactPage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import Pattern from "../resource/patternBack.png";

function ContactPage(props) {
  return (
    <div
      className="contact-container"
      style={{
        backgroundImage: `url(${Pattern})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="title">
        <FontAwesomeIcon
          icon={faPhone}
          size="3x"
          style={{ marginTop: "30px", marginRight: "20px" }}
        />
        <Name
          text={"contact"}
          styles={{
            color: "black",
            fontFamily: "Rubik, sans-serif",
            fontSize: "60px",
          }}
        />
      </div>
      <div>
        <Name
          text={"Handphone : 85799932"}
          styles={{
            color: "black",
            fontFamily: "Rubik, sans-serif",
            fontSize: "40px",
            marginRight: "300px",
            marginBottom: "20px",
          }}
        />
      </div>
      <div>
        <Name
          text={"whatsapp : 85799932"}
          styles={{
            color: "black",
            fontFamily: "Rubik, sans-serif",
            fontSize: "40px",
            marginBottom: "20px",
            marginRight: "340px",
          }}
        />
      </div>
      <div>
        <Name
          text={"telegram : @zhmasternus"}
          styles={{
            color: "black",
            fontFamily: "Rubik, sans-serif",
            fontSize: "40px",
            marginBottom: "20px",
            marginRight: "260px",
          }}
        />
      </div>
      <div>
        <Name
          text={"Email : czh152103@gmail.com"}
          styles={{
            color: "black",
            fontFamily: "Rubik, sans-serif",
            fontSize: "40px",
            marginBottom: "20px",
            marginRight: "180px",
          }}
        />
      </div>
      <div>
        <Name
          text={"LinkedIn : linkedin.com/in/cheng-zihao-870a77246"}
          styles={{
            color: "black",
            fontFamily: "Rubik, sans-serif",
            fontSize: "40px",
            marginBottom: "20px",
            marginLeft: "220px",
          }}
        />
      </div>
    </div>
  );
}
export default ContactPage;
